import React from 'react';
import './ClausulasModalContent.css';
import CheckIcon from '../Icons/Check.icon';
import SafeHtmlContent from '../Common/SafeHtmlContent';

interface ClausulasModalContentProps {
  modalMessage: string;
  clausulasAceptadas: boolean;
  onClausulasChange: (accepted: boolean) => void;
  onAprobar: () => void;
  onRechazar: () => void;
  onGestionarCups: () => void;
}

const ClausulasModalContent: React.FC<ClausulasModalContentProps> = ({
  modalMessage,
  clausulasAceptadas,
  onClausulasChange,
  onAprobar,
  onRechazar,
  onGestionarCups
}) => {
  return (
    <>
      {/* Body - Contenido fijo, solo scroll en la caja de cláusulas */}
      <div className="clausulas-content">
        {/* Texto descriptivo - siempre visible */}
        <p className="clausulas-description">
          Revisa el clausulado y seleccione cómo deseas gestionar este anexo: aprobar o rechazar en su totalidad.
        </p>
        
        {/* Solo la caja de cláusulas tiene scroll */}
        <div className="clausulas-box custom-scrollbar">
          <SafeHtmlContent
            htmlContent={modalMessage}
            fallbackText="No hay información de cláusulas disponible."
            className="clausulas-html-content"
          />
        </div>

        {/* Radio button - siempre visible */}
        <div className="clausulas-checkbox-container">
          <label className="clausulas-checkbox-label">
            <input
              type="radio"
              checked={clausulasAceptadas}
              onChange={(e) => onClausulasChange(e.target.checked)}
              className="clausulas-checkbox"
            />
            <span className="clausulas-checkbox-text">
              Confirmo que he leído y acepto las cláusulas.
            </span>
          </label>
        </div>
      </div>
      
      {/* Footer - Siempre visible */}
      <div className="clausulas-footer">
        {/* Botones izquierda */}
        <div className="clausulas-buttons-left">
          <button
            type="button"
            onClick={onAprobar}
            disabled={!clausulasAceptadas}
            className={`clausulas-button-approve ${clausulasAceptadas ? 'enabled' : 'disabled'}`}
          >
            <CheckIcon style={{ width: '16px', height: '16px' }} />
            Aprobar anexo
          </button>
          <button
            type="button"
            onClick={onRechazar}
            disabled={!clausulasAceptadas}
            className={`clausulas-button-reject ${clausulasAceptadas ? 'enabled' : 'disabled'}`}
          >
            ✕ Rechazar anexo
          </button>
        </div>

        {/* Botón derecha */}
        <button
          type="button"
          onClick={onGestionarCups}
          disabled={!clausulasAceptadas}
          className={`clausulas-button-cups ${clausulasAceptadas ? 'enabled' : 'disabled'}`}
        >
          Gestionar por CUPS
        </button>
      </div>
    </>
  );
};

export default ClausulasModalContent;